import CommentEditorContainer from './containers/CommentEditorContainer'

export default CommentEditorContainer
